import { render, staticRenderFns } from "./mySide.vue?vue&type=template&id=4797a5b2&scoped=true"
import script from "./mySide.vue?vue&type=script&lang=js"
export * from "./mySide.vue?vue&type=script&lang=js"
import style0 from "./mySide.vue?vue&type=style&index=0&id=4797a5b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4797a5b2",
  null
  
)

export default component.exports